<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { observePassiveReasons, pagerPassiveReason } from '@fusapp-work/ui-kit/cosmos'
import { useRoute, useI18n } from '@fusapp-work/shell'
import { useCurrentSession } from './composables/useCurrentSession'
import ConsoleShell from './components/shell/ConsoleShell.vue'

const route = useRoute()
const { state } = useCurrentSession()
const { t } = useI18n()
let stopReasons: (() => void) | undefined
onMounted(() => {
  stopReasons = observePassiveReasons(document.body, element => {
    if (!element.matches('.fw-list-pager-step')) return undefined
    return pagerPassiveReason(element, {
      first: t('listPager.first'),
      previous: t('listPager.previous'),
      next: t('listPager.next'),
      last: t('listPager.last'),
      firstPageReason: t('listPager.firstPageReason'),
      lastPageReason: t('listPager.lastPageReason'),
    })
  })
})
onBeforeUnmount(() => stopReasons?.())
</script>

<template>
  <router-view v-if="route.name === 'login' || route.name === 'forbidden'" />
  <ConsoleShell v-else-if="state.status === 'authenticated'">
    <router-view />
  </ConsoleShell>
</template>
